import { TemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
<!-- BOTTOM HEADER: TABS + MENU (Desktop/Tablet Only) -->

<div class="contextual-fluid">
  <slot name="sectionTitle"></slot>
  <div class="right-group">
    <div class="contextual-links">
      <slot name="primaryMenu"></slot>
    </div>
    <div class="contextual-label">
      <slot name="label-btn"></slot>
    </div>
  </div>

</div>
`

class NavHeaderContextual extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderContextual connectedCallback', this)
  }
}

customElements.define('ts-navheader-contextual', NavHeaderContextual)
